import { render, staticRenderFns } from "./CancelCreateInput.vue?vue&type=template&id=2f22833a&scoped=true"
import script from "./CancelCreateInput.vue?vue&type=script&lang=js"
export * from "./CancelCreateInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f22833a",
  null
  
)

export default component.exports